import Input from 'component/atom/forms/input/input/Input';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import React, { useState } from 'react';
import UploadFile from 'component/atom/forms/upload-file/UploadFile';
import { useFormikContext } from 'formik';
import styles from './DocumetnForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
const DocumentForm = ({ allowedExtensions, onClose }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isViewDoc, setIsViewDoc] = useState(false);
  const formik = useFormikContext();
  const handleChange = () => {
    if (!formik.values.isURL) {
      formik.setFieldValue('uploadedFile', '');
      formik.setFieldValue('file.fileName', '');
      formik.setFieldValue('file.contentType', '');
      formik.setFieldValue('file.fileContent', '');
    } else {
      formik.setFieldValue('url', '');
    }
    formik.setFieldValue('isURL', !formik.values.isURL);
  };

  const handleFileRemove = () => {
    formik.setFieldValue('uploadedFile', '');
    formik.setFieldValue('file.fileName', '');
    formik.setFieldValue('file.contentType', '');
    formik.setFieldValue('file.fileContent', '');
    formik.setFieldValue('url', '');
  };

  const fileToBinary = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject('No file provided');
        return;
      }
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        const binaryData = new Uint8Array(reader.result);

        resolve({
          fileName: file.name,
          contentType: file.type,
          fileContent: binaryData,
        });
      };
      reader.onerror = (error) => reject('Error reading file: ' + error);
    });
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject('No file provided');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert to Base64

      reader.onload = () => {
        const base64String = reader.result.split(',')[1]; // Remove DataURL prefix
        resolve({
          fileName: file.name,
          contentType: file.type,
          fileContent: base64String,
        });
      };

      reader.onerror = (error) => reject('Error reading file: ' + error);
    });
  };
  return (
    <form
      className="formCont"
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      {/* <div>
        <RadioGroup
          name="uploadOrUrl"
          selectedValue={formik.values.isURL}
          onChange={handleChange}
          options={[
            { value: false, label: 'Upload' },
            { value: true, label: 'Add URL' },
          ]}
        />
      </div> */}

      {formik.values.url || formik.values.uploadedFile ? (
        <div
          className={styles['file-name-container']}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* <img
                src="/images/file-icon.svg"
                alt="File Icon"
                className={styles['file-icon']}
              />
              <span className={styles['file-name']}>
                {formik.values.file.fileName ||
                  formik.values.uploadedFile?.name}
              </span>
              <img
                className={styles['close-icon']}
                src="/images/close-grey.svg"
                alt="Remove"
                onClick={handleFileRemove}
              /> */}

          <div className={styles.document}>
            <SvgWithBranding type="node-file" />
            <div className={styles.text}>
              <p>
                {formik.values.file.fileName ||
                  formik.values.uploadedFile?.name ||
                  'Document'}
              </p>

              <span>Document</span>
            </div>
          </div>
          {isHovered && (
            <div className={styles['content-document']}>
              <Button
                opicBackground
                label="View"
                onClick={() => {
                  if (formik.values.url) {
                    window.open(formik.values.url, '_blank');
                  } else if (formik.values.file.fileContent) {
                    const blob = new Blob(
                      [
                        new Uint8Array(
                          atob(formik.values.file.fileContent)
                            .split('')
                            .map((char) => char.charCodeAt(0))
                        ),
                      ],
                      { type: formik.values.file.contentType }
                    );
                    const url = URL.createObjectURL(blob);
                    window.open(url, '_blank');
                  }
                }}
              />
            </div>
          )}
          <SvgWithBranding
            type="delete_table"
            className={styles.deleteIcon}
            onClick={handleFileRemove}
          />
        </div>
      ) : (
        <UploadFile
          title={`Upload Document`}
          value={formik.values.file.fileName}
          name="file"
          onChange={async (event) => {
            const file = event.target.value;
            if (!file) return;
            formik.setFieldValue('uploadedFile', file);
            try {
              const fileData = await fileToBase64(file);
              formik.setFieldValue('file', fileData);
              formik.setFieldValue('url', '');
            } catch (error) {
              console.error('File processing error:', error);
            }
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.file?.fileName}
          touched={formik.touched.file?.fileName}
          allowedExtensions={allowedExtensions}
        />
      )}

      {/* <Input
          name="Url"
          placeholder="Enter URL"
          value={formik.values.url}
          onChange={(e) => {
            formik.setFieldValue('url', e.target.value);
            formik.setFieldValue('fileName', '');
          }}
          onBlur={formik.handleBlur}
          error={formik.errors.url}
          touched={formik.touched.url}
        />
  */}

      {/* <div className="footer">
        <Button
          label="Cancel"
          variant="#B3B5BD"
          transparent
          onClick={onClose}
        />

        <Button label="Save" onClick={formik.handleSubmit} />
      </div> */}
    </form>
  );
};
export default DocumentForm;
